/*
 * sp-location.js — el mapa de Google de la tarjeta del local (bloque sp_trust con loc_address, snippets/sp-location-card.liquid;
 * kit Shopify maker, 2026-10-18, PAR-138, CONTRACTS §B.1).
 *
 * El embed de Google Maps pesa cientos de KB (JS, fuentes y teselas) y un iframe con loading="lazy" igual baja a 1 250-2 500 px
 * del viewport: en la ficha entraría en la carga. Por eso la tarjeta trae el mapa FIJO (una imagen propia) y la URL del embed
 * en data-sp-loc-src, y este script crea el iframe recién cuando la persona toca el botón "Tocá para ver el mapa" (o la caja):
 *   - nunca en la carga, ni al entrar en pantalla ni al pasar el mouse;
 *   - el iframe va encima del mapa fijo (position absolute en sp-location.css): la caja no cambia de tamaño, sin CLS;
 *   - mientras carga, la píldora queda visible con data-sp-loc-loading ("Cargando el mapa…", sin interacción: aria-hidden y
 *     pointer-events none por CSS) y se va cuando el iframe terminó de cargar (data-sp-loc-ready), que entra con un fundido;
 *     con prefers-reduced-motion, sin fundido (CSS);
 *   - el foco pasa al iframe, con su title ("Mapa: <dirección>");
 *   - sin listeners de scroll ni de gesto: un click en cada caja (cubre el toque y el teclado).
 * Idempotente (lo pide cada tarjeta) y con el editor de temas: shopify:section:load arma las tarjetas nuevas.
 */
(function () {
  'use strict';
  if (window.spLocation && window.spLocation.__kit) return;

  function mount(box) {
    if (!box || box.hasAttribute('data-sp-loc-on')) return;
    var src = box.getAttribute('data-sp-loc-src');
    if (!src) return;
    box.setAttribute('data-sp-loc-on', '');
    var f = document.createElement('iframe');
    f.className = 'sp-loc__frame';
    f.title = box.getAttribute('data-sp-loc-title') || '';
    f.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    f.setAttribute('allowfullscreen', '');
    var btn = box.querySelector('.sp-loc__hint');
    var hadFocus = btn && document.activeElement === btn;
    if (btn) {
      var label = btn.querySelector('span');
      if (label && box.getAttribute('data-sp-loc-loading')) label.textContent = box.getAttribute('data-sp-loc-loading');
      btn.setAttribute('aria-hidden', 'true');
      btn.setAttribute('tabindex', '-1');
    }
    f.addEventListener('load', function () {
      box.setAttribute('data-sp-loc-ready', '');
      if (btn && btn.parentNode) btn.parentNode.removeChild(btn);
    });
    f.src = src;
    box.appendChild(f);
    if (hadFocus) {
      try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); }
    }
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var boxes = root.querySelectorAll('[data-sp-loc-map]');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      if (box.hasAttribute('data-sp-loc-watch')) continue;
      box.setAttribute('data-sp-loc-watch', '');
      box.addEventListener('click', function (e) { mount(e.currentTarget); });
    }
  }

  window.spLocation = { __kit: true, init: init, mount: mount };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
